import { makeStyles } from '@rbx/ui';

const useConversationMessageStyles = makeStyles()((theme) => ({
  soloStreamingIndicator: {
    marginTop: -5,
  },
  replyWrapper: {
    '&:last-of-type > *': {
      marginBottom: theme.spacing(3),
    },
  },
  reply: {
    display: 'block',
    fontSize: 16,
    margin: theme.spacing(3, 0),
    padding: theme.spacing(2.5),
    maxWidth: '100%',
    '& li': {
      marginBottom: theme.spacing(3),
      '&:empty': {
        display: 'none',
      },
    },
    '& li ul': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(3),
    },
    '& p:first-of-type': {
      marginTop: 0,
    },
    '& p:last-of-type': {
      marginBottom: 0,
    },
    '& p': {
      marginBottom: theme.spacing(3),
    },
    '& p:only-child, p:empty': {
      marginBottom: 0,
    },
    '& h1, & h2, & h3, & h4, & h5, & h6': {
      lineHeight: '140%',
      fontWeight: 500,
      color: theme.palette.common.white,
    },
    '& *': {
      overflowWrap: 'break-word',
    },
    '& a *': {
      color: theme.palette.actionV2.primaryBrand.fill,
    },
    // allow headers, code to have their own separate font sizes
    '& *:not(.inline-code, pre, h1, h2, h3, h4, h5, h6), & * *:not(.inline-code, pre, h1, h2, h3, h4, h5, h6)':
      {
        fontSize: 'inherit',
      },
    '& h1:first-child, & h2:first-child, & h3:first-child': {
      marginTop: 0,
    },
    '& pre, & .inline-code': {
      fontSize: 14,
    },
    '& .inline-code': {
      paddingInline: 4,
    },
  },
  userReplyWrapper: {
    textAlign: 'right',
  },
  userReply: {
    textAlign: 'left',
    color: theme.palette.text.primary,
    background: theme.palette.background.tooltips,
    borderRadius: '12px 0 12px 12px',
  },
  botReply: {
    color: theme.palette.actionV2.primary.fill,
    background: theme.palette.surface[200],
    borderRadius: '0 12px 12px 12px',
  },
  optInDivider: {
    margin: '20px 0px',
  },
  subBlock: {
    marginTop: 48,
    [theme.breakpoints.down('Medium')]: {
      marginTop: 16,
    },
    width: '100%',
    flexWrap: 'nowrap',
    display: 'flex',
  },
  declineButton: {
    marginRight: 20,
    color: theme.palette.content.standard,
    backgroundColor: theme.palette.actionV2.secondary.fill,
  },
  responseContainer: {
    width: `calc(100% - 64px)`,
    display: 'flex',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('Medium')]: {
      flexWrap: 'wrap',
    },
  },
}));

export default useConversationMessageStyles;
